import './view.scss';

document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.mobile-menu-item');

    items.forEach(item => {
        const toggle = item.querySelector('.menu-toggle');
        const panel = item.querySelector('.menu-panel');

        // Ensure the panel starts closed
        if (!item.classList.contains('open')) {
            gsap.set(panel, { height: 0, opacity: 0 });
        }

        if (toggle && panel) {
            toggle.addEventListener('click', () => {
                const isOpen = item.classList.contains('open');

                if (isOpen) {
                    // Close the panel using GSAP
                    item.classList.remove('open');
                    gsap.to(panel, {
                        duration: 0.2,
                        height: 0,
                        opacity: 0,
                        ease: 'power2.out',
                    });
                    toggle.setAttribute('aria-expanded', 'false');
                } else {
                    // Open the panel using GSAP
                    item.classList.add('open');
                    gsap.to(panel, {
                        duration: 0.2,
                        height: panel.scrollHeight,
                        opacity: 1,
                        ease: 'power2.out',
                    });
                    toggle.setAttribute('aria-expanded', 'true');
                }
            });
        }
    });
});